module.exports = __webpack_public_path__ + "img/1-small.1b74d2ba.png";